import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "gfu-embed gfu-embed--16x9 _flexcntr _ai-c" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 2 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_privacy_placeholder = _resolveComponent("privacy-placeholder")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "gfu-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        ($options.shouldBlockVideo)
          ? (_openBlock(), _createBlock(_component_privacy_placeholder, {
              key: 0,
              class: "gfu-embed__item _bgc--white"
            }))
          : ($options.isVisible)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 1,
                ref: `iframe:${$options.videoUrl}`,
                src: $options.videoUrl,
                class: _normalizeClass(['gfu-embed__item _bgc--primary-dark', {'youtube-player' : $options.isYoutube}]),
                frameborder: "0",
                width: "100%",
                height: "100%",
                loading: "lazy",
                referrerpolicy: "strict-origin-when-cross-origin",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                allowfullscreen: ""
              }, null, 10 /* CLASS, PROPS */, _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_base_button, {
                  theme: "primary",
                  class: "gfu-gallery__play-button",
                  onClick: $options.onPlay
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Common.PlayVideoButton) + " ", 1 /* TEXT */),
                    _createVNode(_component_base_icon, {
                      name: "play-solid",
                      "icon-namespace": "ga",
                      size: "lg"
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}